/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Manage_DescInputs */

const en_jobs_manage_desc = /** @type {(inputs: Jobs_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your job search criteria`)
};

const de_jobs_manage_desc = /** @type {(inputs: Jobs_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte deine Suchkriterien`)
};

const fr_jobs_manage_desc = /** @type {(inputs: Jobs_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère tes critères de recherche`)
};

const es_jobs_manage_desc = /** @type {(inputs: Jobs_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione sus criterios de búsqueda`)
};

const it_jobs_manage_desc = /** @type {(inputs: Jobs_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci i tuoi criteri di ricerca lavoro`)
};

const nl_jobs_manage_desc = /** @type {(inputs: Jobs_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer je zoekcriteria voor banen`)
};

const pl_jobs_manage_desc = /** @type {(inputs: Jobs_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj kryteriami wyszukiwania pracy`)
};

const fi_jobs_manage_desc = /** @type {(inputs: Jobs_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallinnoi hakukriteerejäsi`)
};

const da_jobs_manage_desc = /** @type {(inputs: Jobs_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrer dine søgekriterier`)
};

const sv_jobs_manage_desc = /** @type {(inputs: Jobs_Manage_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantera dina sökkriterier`)
};

/**
* | output |
* | --- |
* | "Manage your job search criteria" |
*
* @param {Jobs_Manage_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_manage_desc = /** @type {((inputs?: Jobs_Manage_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Manage_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_manage_desc(inputs)
	if (locale === "fr") return fr_jobs_manage_desc(inputs)
	if (locale === "es") return es_jobs_manage_desc(inputs)
	if (locale === "it") return it_jobs_manage_desc(inputs)
	if (locale === "nl") return nl_jobs_manage_desc(inputs)
	if (locale === "pl") return pl_jobs_manage_desc(inputs)
	if (locale === "fi") return fi_jobs_manage_desc(inputs)
	if (locale === "da") return da_jobs_manage_desc(inputs)
	if (locale === "sv") return sv_jobs_manage_desc(inputs)
	return en_jobs_manage_desc(inputs)
});